import React from 'react';
import {render} from 'react-dom';

import {Header} from './Header.jsx';
import {FileNames} from './FileNames.jsx';
import {FileDiffs} from './FileDiffs.jsx';

var DiffPullPopup = React.createClass({
	getInitialState: function(){
		return {
				"activeFile": "", 
				"activeFileData": "",
				"files": 0, 
				"totalFiles": 0,
				"width": 1000, height: 630,
				"modifiedWidth": 0,
				"modifiedHeght": 0,
				"errMsg": ""
				}
	},
	handleCloseClick: function(){
		this.props.pullDiff(false);
	},
	handlePullClick: function(flag, files){
		this.props.pullDiff(flag, files);
	},
	setActiveFile: function(file, data){
		this.setState({"activeFile": file, "activeFileData": data});
	},
	countFiles: function(files){
		this.setState({"files": files});
	},
	setTotalFiles: function(files){
		this.setState({"totalFiles": files})
	},
	componentDidMount : function() {
  		var self = this;
  		$('#resizeDiv')
		.resizable({
			// maxHeight: 250,
      		// maxWidth: 1100,
      		minHeight: 630,
      		minWidth: 1100,
			start: function(e, ui) {
				// console.log('resizing started');
			},
			resize: function(e, ui) {
				self.setState({modifiedWidth: ui.size.width - ui.originalSize.width});
				self.setState({modifiedHeght: ui.size.height - self.state.height});
			},
			stop: function(e, ui) {
				// console.log('resizing stopped');
			}
		});


      	window.addEventListener('resize', this.handleResize); // for changing list view to grid view
  	},
  	componentWillUnmount: function() {
      	window.removeEventListener('resize', this.handleResize); // for changing the list view to grid view
  	},
  	handleResize: function(e){
  		this.setState({modifiedHeght: 0});
    	this.setState({width: window.innerWidth}); // for changing list view to grid view
    	if(this.state.width > 1475){
    		this.setState({width: 1100, height: 630});
    	} else if(this.state.width <= 1475 && this.state.width >= 1220){
      		this.setState({width: 1000, height: 630});
    	} else if (this.state.width < 1220){
    		this.setState({width: 800, height: 650});
    	}
  	},
  	errorMsg: function(){
  		this.setState({errMsg: ""})
  	},
  	stopPropagation: function(e){
  		e.stopPropagation();
  	},
	render: function() {
		return(
			<div className="modal__mask" onClick ={this.handleCloseClick}>
				<div className="modal__content modal--xl" id = "resizeDiv" style = {{width: this.state.width, height: this.state.height}} onClick = {this.stopPropagation} >
				  <div className="modal__header">
				    <h3 className="modal__header--title">Choose Files to Download</h3>
				    <p className="modal__header--desc">Changes have been made in the Hub since the last time files were pushed and the following files are now out-of-sync. Selecting the "<i className="fa fa-check"> </i>" next to the individual file will pull your remote file. Selecting the "<i className="fa fa-close"> </i>" will keep your local file in its current state.</p>
				    <a href="javascript:void(0)" onClick ={this.handleCloseClick} className="modal__close"><i className="fa  fa-close"> </i></a> 
				  </div>
				  <div className="modal__body">
				    <div className="diff__cont">
				      <Header 	activeFile = {this.state.activeFile} 
				      			selectedFiles = {this.state.files}
				      			totalFiles = {this.state.totalFiles} />
				      <div className="diff__row">
				       	<FileNames 	handleCloseClick = {this.handleCloseClick} 
				       				data = {this.props.pullDiffData}
				       				setActiveFile = {this.setActiveFile}
				       				activeFile = {this.state.activeFile}
				       				countFiles = {this.countFiles}
				       				totalFiles = {this.setTotalFiles}
				       				handlePullClick = {this.handlePullClick}
				       				modifiedHeght = {this.state.modifiedHeght} />
						<FileDiffs 	data = {this.state.activeFileData} 
									modifiedHeght = {this.state.modifiedHeght} />
				      </div>
				    </div>
				  </div>
				</div>
			</div>
		);
	}
});

export {DiffPullPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/DiffPullPopup/index.jsx
 **/